import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "topbar px-2 px-md-5 py-2" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-md-8 d-flex justify-content-start align-items-center" }
const _hoisted_4 = { class: "contact-details" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-phone mx-2" }, null, -1)
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-envelope mx-2" }, null, -1)
const _hoisted_9 = { class: "col-12 col-md-4 d-none d-md-block" }
const _hoisted_10 = { class: "social-media" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-phone" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-whatsapp" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-twitter" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-instagram" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

import { ContactChannelType } from '@/composables/types';
import { useGlobalStore } from '@/stores';
import { reactive, onMounted } from 'vue';

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const globalStore = useGlobalStore();

const channels = reactive({
  phone: null as null | ContactChannelType,
  email: null as null | ContactChannelType,
  whatsapp: null as null | ContactChannelType,
  twitter: null as null | ContactChannelType,
  instagram: null as null | ContactChannelType,
});

onMounted(() => {
  if (globalStore.contactChannels.length <= 0) {
    globalStore.fetchContactChannels(undefined);
  }
  channels.phone = globalStore.contactChannelByType('phone');
  channels.email = globalStore.contactChannelByType('email');
  channels.whatsapp = globalStore.contactChannelByType('whatsapp');
  channels.twitter = globalStore.contactChannelByType('twitter');
  channels.instagram = globalStore.contactChannelByType('instagram');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (channels.phone != null)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: (channels.phone.link as string),
                target: "_blank"
              }, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(channels.phone.value), 1)
              ], 8, _hoisted_5))
            : _createCommentVNode("", true),
          (channels.email != null)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: (channels.email.link as string),
                target: "_blank"
              }, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(channels.email.value), 1)
              ], 8, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (channels.phone != null)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: (channels.phone.link as string),
                target: "_blank"
              }, _hoisted_13, 8, _hoisted_11))
            : _createCommentVNode("", true),
          (channels.whatsapp != null)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: (channels.whatsapp.link as string),
                target: "_blank"
              }, _hoisted_16, 8, _hoisted_14))
            : _createCommentVNode("", true),
          (channels.twitter != null)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: (channels.twitter.link as string),
                target: "_blank"
              }, _hoisted_19, 8, _hoisted_17))
            : _createCommentVNode("", true),
          (channels.instagram != null)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: (channels.instagram.link as string),
                target: "_blank"
              }, _hoisted_22, 8, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})